import AREAS from './areas'
import CATEGORIA from './categoria'
import PRIORIDAD from './prioridad'

export class CambioSedeNotification {
  #notification

  constructor(notification) {
    this.#notification = notification
  }

  create(args) {
    const notification = new this.#notification()
    notification.responsable = args.responsable
    notification.afectado = args.afectado
    notification.titulo = AREAS.ENLACE_COMISARIA + ': Cambio de sede'
    notification.mensaje = args.mensaje
    notification.prioridad = PRIORIDAD.MEDIA
    notification.categoria = CATEGORIA.INFORMATIVA

    return notification
  }
}
